import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { Person } from '../Models/person';
import { theme } from '../Mui/Theme';
import { getPerson } from '../firebase/Database/GetPerson';
import { removeSpecificPersonFromSession } from '../firebase/Database/RemoveSpecificPersonFromSession';
import { BoxBodyText } from './Text/BoxBodyText';

interface boxPersonProps {
    personId: string;
    sessionId: string;
    remove: boolean;
}

export const BoxPerson: React.FC<boxPersonProps> = ({
    personId,
    sessionId,
    remove,
}) => {
    const [person, setPerson] = useState<Person | null>(null);

    useEffect(() => {
        getPerson(personId).then((res) => {
            setPerson(res);
        });
    }, [personId]);

    const removePersonHandler = () => {
        if (person) {
            removeSpecificPersonFromSession(personId, sessionId);
        }
    };

    return (
        <>
            {person !== null && (
                <Grid
                    container
                    direction="row"
                    sx={{
                        margin: '10px 5px',
                        height: '50px',
                        maxWidth: '90%',
                        borderRadius: '30px',
                        background: remove
                            ? '#eb403499'
                            : `${theme.palette.secondary.main}`,
                        cursor: remove ? 'pointer' : 'default',
                        '&:hover': {
                            background: remove
                                ? '#eb4034'
                                : `${theme.palette.secondary.dark}`,
                        },
                        color: 'primary.main',
                    }}
                    onClick={remove ? removePersonHandler : () => {}}
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Grid item>
                        <BoxBodyText>
                            {person.firstName} {person.lastName}
                        </BoxBodyText>
                    </Grid>
                </Grid>
            )}
        </>
    );
};
